import env from '@config/env'
import isServer from '@client/utils/isServer'
import handlePathname from '@client/utils/handlePathname'

const appKeyMap = {
  br: env.brBlipAppKey,
  us: env.usBlipAppKey,
}

const buildChatbot = async locale => {
  const shouldInstantiateBlip =
    !isServer && !window.blipClient && window.BlipChat

  if (shouldInstantiateBlip) {
    window.blipClient = new window.BlipChat()

    window.blipClient
      .withAppKey(appKeyMap[locale])
      .withButton({
        color: '#710252',
        icon:
          'https://blipmediastore.blob.core.windows.net/public-medias/Media_245a9ff5-e5a4-4a41-91d8-ac5683808c92',
      })
      .withCustomCommonUrl('https://gympass.chat.blip.ai/')
      .build()
  }
}

const openBlipChat = () => {
  const isClosed =
    document.getElementsByClassName('blip-chat-iframe-opened').length === 0

  if (isClosed) {
    // eslint-disable-next-line no-unused-expressions
    window.blipClient?.toogleChat()
  }
}

export const openChat = timeout => {
  if (timeout) {
    setTimeout(() => {
      openBlipChat()
    }, timeout)
  } else {
    openBlipChat()
  }
}

const destroyChat = () => {
  if (!isServer && window.blipClient) {
    // eslint-disable-next-line no-unused-expressions
    window.blipClient?.destroy()
    window.blipClient = null
  }
}

const acceptableRoutes = ['/simulate/company-info', '/simulate/checkout']

export const handleChatbot = pathname => {
  const { path, country } = handlePathname(pathname)

  const isAcceptableRoute = acceptableRoutes.includes(path)

  if (!isAcceptableRoute) {
    destroyChat()
    return
  }

  buildChatbot(country)
}
